import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
@Pipe({
  name: 'fileNameWithoutExtension',
})
export class FileNameWithoutExtension implements PipeTransform {
  transform(value: string): string {
    return value.split('.').length == 0 ? value : value.split('.').slice(0, -1).join('.');
  }
}
